import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacypolicy-container">
      <h1>Privacy Policy</h1>
      <p>Your privacy is important to us. We ensure that your personal data is protected and only used in accordance with our policy.</p>
    </div>
  );
};

export default PrivacyPolicy;
